import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-responsive-bs4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import $ from "jquery";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import { useEffect, useRef } from "react";
import moment from "moment";

const TablaPedidos = ({ datos }) => {
    const tableRef = useRef();
    useEffect(() => {
        $(tableRef.current).DataTable({
            data: datos,
            columns: [
                {
                    targets: 0,
                    title: "Id",
                    data: "id"
                },
                {
                    targets: 1,
                    title: "Nombre Cliente",
                    data: "Cliente",
                    render: (cliente) => cliente?.nombreCompleto || "Sin nombre"
                },
                {
                    targets: 2,
                    title: "Fecha",
                    data: "fecha",
                    render: (fecha) => {
                        const f = moment(fecha);
                        return f.isValid() ? f.format("DD/MM/YYYY") : "N/A";
                    }
                },
                {
                    targets: 3,
                    title: "Estado",
                    data: "estado",
                    render: (data) => {
                        let badgeClass = "bg-warning text-dark";
                        if (data === "Pendiente") badgeClass = "bg-warning";
                        else if (data === "Programada") badgeClass = "bg-success";
                        else if (data === "Completada") badgeClass = "bg-primary";
                        else if (data === "Cancelada") badgeClass = "bg-danger";
                        return `<span class="badge ${badgeClass}">${data}</span>`;
                    },
                },
                {
                    targets: 4,
                    title: "Total",
                    // El transform de HomeBuscarPedidos ya calcula el total y
                    // renombra pedidoDetalles a detalles, asi que pedir
                    // "pedidoDetalles" aqui disparaba el aviso de DataTables.
                    data: "total",
                    render: (data, type) => {
                        const monto = parseFloat(data) || 0;
                        // Al ordenar y filtrar se usa el numero; al mostrar, el formato.
                        return type === "display" ? `L. ${monto.toFixed(2)}` : monto;
                    }
                }
            ],

            paging: true,
            lengthChange: true,
            pageLength: 10,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: true,
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            dom:
                "<'row mb-3'<'col-sm-12 col-md-6 text-left'B><'col-sm-12 col-md-6 text-right'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            responsive: true,
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                infoPostFix: "",
                thousands: ",",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                zeroRecords: "Sin resultados encontrados",
                search: "Buscar",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            destroy: true,
        });
        //}
    }, [datos]);

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                id="tablaBuscarPedidos"
                className="table table-bordered table-hover nowrap"
                style={{ width: "100%" }}
            ></table>
        </div>
    );
};

export default TablaPedidos;